import React, { useState } from 'react';

/** Only web addresses and inline images are used as a picture source. */
const toSafeImageUrl = (value) => {
    const url = typeof value === 'string' ? value.trim() : '';
    return /^(https?:\/\/|data:image\/|blob:)/i.test(url) ? url : '';
};

/**
 * A user's picture, or their initials when there is no picture (or it cannot be loaded).
 * `className` is the existing circle style of the place it is used (top bar, side bar...);
 * the picture simply fills that circle.
 *
 * @param {{ imageUrl?: string, initials: string, className?: string }} props
 */
const UserAvatar = ({ imageUrl, initials, className = '' }) => {
    const source = toSafeImageUrl(imageUrl);
    const [failedSource, setFailedSource] = useState('');
    const showImage = Boolean(source) && failedSource !== source;

    return (
        <div className={`${className}${showImage ? ' has-image' : ''}`} style={showImage ? { overflow: 'hidden', padding: 0 } : undefined}>
            {showImage ? (
                <img
                    src={source}
                    alt=""
                    referrerPolicy="no-referrer"
                    onError={() => setFailedSource(source)}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
            ) : (
                initials
            )}
        </div>
    );
};

export default UserAvatar;
